import { getLocal } from "../Local/local";

export const createPost = async () => {
  let payload = {
    image: "",
    name: "",
    occupation: "",
    email: "",
    mobile: 0,
    location: "",
    github: "",
    linkedin: "",
    about: "",
    techSkills: [{ skillsName: "" }],
    softSkills: [{ skillsName: "" }],
    education: [{ coursename: "", institute: "", from: "", to: "" }],
    experience: [{ companyName: "", role: "", from: "", to: "" }],

    insterest: [{ insterest: "" }],
    projects: [
      {
        projectName: "",
        github: "",
        deployment: "",
        video: "",
        shortDesc: "",
        fea1: "",
        fea2: "",
        fea3: "",
        techstacks: "",
      },
    ],
    otherProjects: [
      { projectName: "", github: "", deployment: "", video: "", shortDesc: "" },
    ],
    languages: [{ lang: "" }],
    accomplishment: [{ head: "", desc: "" }],
  };
  let response = await fetch(
    "https://resume-builder-server-gi2i.onrender.com/resume",
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  let data = await response.json();
  return data;
};

export const updatePost = async (payload) => {
  let ID = getLocal("resume_builder");
  let res = await fetch(
    `https://resume-builder-server-gi2i.onrender.com/resume/${ID}`,
    {
      method: "PATCH",
      body: payload,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  let data = await res.json();
  return data;
};

export const getSubmit = async () => {
  let ID = getLocal("resume_builder");
  let res = await fetch(
    `https://resume-builder-server-gi2i.onrender.com/resume/${ID}`
  );
  let data = await res.json();

  let {
    image,
    name,
    occupation,
    email,
    mobile,
    location,
    github,
    linkedin,
    about,
    techSkills,
    softSkills,
    education,
    experience,
    insterest,
    projects,
    otherProjects,
    languages,
    accomplishment,
  } = data.resumes;
  let flag = true;
  if (image === "" || image === "pic.jpg") {
    flag = "Please upload image";
  } else if (name === "") {
    flag = "Please Enter your name";
  } else if (occupation === "") {
    flag = "Please Enter your occupation";
  } else if (email === "") {
    flag = "Please Enter email address";
  } else if (mobile === "" || mobile === 0) {
    flag = "Please enter mobile number";
  } else if (location === "") {
    flag = "Please enter location";
  } else if (github === "") {
    flag = "Please Enter github username";
  } else if (linkedin === "") {
    flag = "Please enter linkedin username";
  } else if (about === "") {
    flag = "Please write something about yourself";
  } else {
    techSkills.forEach((el) => {
      if (el.skillsName === "") {
        flag = "Please enter technical skill";
      }
    });
    softSkills.forEach((el) => {
      if (el.skillsName === "") {
        flag = "Please enter technical skill";
      }
    });

    education.forEach(({ coursename, institute, from, to }) => {
      if (coursename === "" || institute === "" || from === "" || to === "") {
        flag = "Please fill educational details";
      }
    });

    // experience.forEach(({companyName, role, from, to}) => {
    //     if(companyName==="" || role==="" || from==="" || to===""){
    //         flag = "Please fill experience details"
    //     }
    // })

    insterest.forEach((el) => {
      if (el.insterest === "") {
        flag = "Please enter your interests";
      }
    });

    projects.forEach(
      ({
        projectName,
        github,
        deployment,
        video,
        shortDesc,
        fea1,
        fea2,
        fea3,
        techstacks,
      }) => {
        if (
          projectName === "" ||
          github === "" ||
          deployment === "" ||
          video === "" ||
          shortDesc === "" ||
          fea1 === "" ||
          fea2 === "" ||
          fea3 === "" ||
          techstacks === ""
        ) {
          flag = "Please enter project details";
        }
      }
    );

    // otherProjects.forEach(({projectName, github, deployment,video, shortDesc}) => {
    //     if(projectName==="" || github==="" || deployment==="" || video==="" ||
    //     shortDesc===""){
    //        flag = "Please enter other projects details"
    //     }
    // })

    languages.forEach((el) => {
      if (el.lang === "") {
        flag = "Please enter languages, like Hindi, English";
      }
    });
  }
  return flag;
};
